import React, {CSSProperties, useMemo} from "react";
import {TDAForm} from "@dreebit-registry/vsm-microservice-components";
import {useTranslation} from "react-i18next";
import {FileListItem} from "../FileList";


interface Props {

    files: FileListItem[]
    onChange?: (index: any, value: unknown) => void
    onReset?: () => void
    initialValues?: { [key: string]: any }
    formStyle?: CSSProperties
    onValuesChange?: (values: { [p: string]: any }) => void,
    userLanguage?: string
}


const FileListFilter = ({files, onReset, initialValues, onValuesChange, userLanguage}: Props) => {

    const {t, i18n} = useTranslation();
    const languageTranslator = new Intl.DisplayNames([i18n.language], { type: 'language' });

    const inputAttributes = useMemo(() => {

        const uniqueLanguages = Array.from(new Set(
            files.map(file => file.language).filter((l): l is string => !!l)
        ));
        const uniqueCategories = Array.from(new Set(
            files.map(file => file.category).filter((c): c is string => !!c)
        ));



        const languageOptions = uniqueLanguages.map(lang => ({
            value: lang,
            name: languageTranslator.of(lang) || lang,
        })).sort((a, b) => {

            if (a.value === userLanguage) return -1;
            if (b.value === userLanguage) return 1;

            return a.name.localeCompare(b.name);
        });

        const categoryOptions = uniqueCategories.map(category => ({
            value: category,
            name: t(category),
        })).sort((a, b) => a.name.localeCompare(b.name));

        return [
            {
                index: "language",
                name: t("Language"),
                type: "string",
                disabled: false,
                inputType: "select",
                list: true,
                multiple: true,
                value: [],
                optionValues: languageOptions
            },
            {
                index: "category",
                name: t("Category"),
                type: "string",
                disabled: false,
                inputType: "select",
                list: true,
                multiple: true,
                value: [],
                optionValues: categoryOptions
            }
        ];
    }, [files, t, i18n.language, userLanguage]);

    return (
        <TDAForm
            attributes={inputAttributes}
            layout={'column'}
            useFilterLabel={false}
            onValuesChange={onValuesChange}
            onReset={onReset}
            initialFormValues= {initialValues}
            formStyle={{width: '100%'}}
            resetButtonSxStyles={{width: "100%", mt: "5px"}}
        />
    );
};

export default FileListFilter;